import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

const money = (v) =>
  Number(v || 0).toLocaleString("it-IT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const badgeClass = (type) => {
  if (type === "RECHARGE") return "bg-primary";
  if (type === "BONUS") return "bg-success";
  if (type === "ORDER_PAYMENT") return "bg-danger";
  if (type === "REFUND") return "bg-warning text-dark";
  return "bg-secondary";
};

const sign = (amount) => (Number(amount || 0) >= 0 ? "+" : "");

const isConsumoNegozio = (m) =>
  String(m?.note || "").startsWith("Consumo in negozio:");

const movementLabel = (m) =>
  isConsumoNegozio(m)
    ? "Consumo in negozio"
    : (m.movement_label || m.type);

const movementNote = (m) =>
  isConsumoNegozio(m)
    ? String(m.note || "").replace(/^Consumo in negozio:\s*/, "")
    : (m.note || "");

const StoricoWalletModal = ({ clientCode, onClose }) => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState("");

  const load = async () => {
    if (!clientCode) return;
    setLoading(true);
    setErrore("");
    try {
      const res = await authFetch(`${API_URL}/api/clienti/${clientCode}/wallet/movements/?_=${Date.now()}`);
      const json = await res.json();
      if (!res.ok) {
        setErrore(json.detail || "Errore caricamento storico wallet.");
        setMovements([]);
        return;
      }
      setMovements(Array.isArray(json.results) ? json.results : []);
    } catch (e) {
      console.error("Errore storico wallet:", e);
      setErrore("Errore rete durante caricamento storico wallet.");
      setMovements([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientCode]);

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,.45)" }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">💰 Storico Wallet</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="text-muted small">
                Ricariche, bonus, pagamenti e rettifiche del credito app.
              </div>
              <button className="btn btn-sm btn-outline-secondary" onClick={load} disabled={loading}>
                {loading ? "Aggiorno..." : "Aggiorna"}
              </button>
            </div>

            {errore && <div className="alert alert-danger">{errore}</div>}

            {loading ? (
              <div className="alert alert-light border">Caricamento storico wallet...</div>
            ) : movements.length === 0 ? (
              <div className="alert alert-light border mb-0">Nessun movimento wallet registrato.</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Data</th>
                      <th>Tipo</th>
                      <th>Credito</th>
                      <th className="text-end">Importo</th>
                      <th>Metodo</th>
                      <th>Promo</th>
                      <th>Operatore</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    {movements.map((m) => (
                      <tr key={m.id}>
                        <td className="small text-muted" style={{ whiteSpace: "nowrap" }}>
                          {m.created_at ? new Date(m.created_at).toLocaleString("it-IT") : "-"}
                        </td>
                        <td>
                          <span className={`badge ${badgeClass(m.type)}`}>
                            {movementLabel(m)}
                          </span>
                        </td>
                        <td>
                          <span className={m.balance_type === "PROMO" ? "badge bg-warning text-dark" : "badge bg-light text-dark border"}>
                            {m.balance_label || m.balance_type}
                          </span>
                        </td>
                        <td className={`text-end fw-bold ${Number(m.amount || 0) < 0 ? "text-danger" : "text-success"}`}>
                          {sign(m.amount)}€{money(m.amount)}
                        </td>
                        <td className="small">{m.payment_method || "-"}</td>
                        <td className="small">{m.campaign_name || "-"}</td>
                        <td className="small">{m.created_by || "-"}</td>
                        <td className="small text-muted">{movementNote(m) || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Chiudi</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoricoWalletModal;
